import React from "react";

const HeaderBlock = ({ data, update, mode }) => {
  const Tag = `h${data.level}`;

  if (mode === "edit") {
    return (
      <>
        <select
          className="form-select mb-2"
          value={data.level}
          onChange={(e) =>
            update({ ...data, level: Number(e.target.value) })
          }
        >
          <option value={1}>H1</option>
          <option value={2}>H2</option>
          <option value={3}>H3</option>
        </select>

        <input
          className="form-control"
          placeholder="Enter heading..."
          value={data.text}
          onChange={(e) =>
            update({ ...data, text: e.target.value })
          }
        />
      </>
    );
  }

  return data.text ? (
    <Tag>{data.text}</Tag>
  ) : (
    <p className="text-muted fst-italic">Empty header</p>
  );
};

export default HeaderBlock;